import { route } from "@circle-react/lib/routes/define";

// Newsletter settings area. Gated behind `email_hub_newsletter_phase_a_enabled`
// at the route layout (`beforeLoad`) and nav layers. Declarations here are
// schema only — callers still must respect the feature flag.
export const newsletterRoutes = {
  overview: route("/settings/newsletter", {
    title: "Newsletters",
    requires: "admin",
    description: "Newsletter overview in the community settings area.",
  }),

  activate: route("/settings/newsletter/activate", {
    title: "Activate newsletter",
    requires: "admin",
    description:
      "Newsletter setup page shown until the community activates its newsletter.",
  }),

  posts: route("/settings/newsletter/posts", {
    title: "Newsletter posts",
    requires: "admin",
    description: "List of newsletter posts.",
  }),

  listContacts: route("/settings/newsletter/lists/:listId", {
    title: "Manage newsletter list",
    requires: "admin",
    description: "Subscriber table for a single newsletter list.",
    pathParams: {
      listId: {
        type: "number",
        description: "Numeric newsletter list identifier.",
      },
    },
  }),

  lists: route("/settings/newsletter/lists", {
    title: "Newsletter lists",
    requires: "admin",
    description: "Manage newsletter lists.",
  }),

  postOverview: route("/settings/newsletter/posts/:id/overview", {
    title: "Newsletter post overview",
    requires: "admin",
    description: "Publication summary and performance of a newsletter post.",
    pathParams: {
      id: {
        type: "number",
        description: "Numeric newsletter post identifier.",
      },
    },
  }),

  postContent: route("/settings/newsletter/posts/:id/content", {
    title: "Newsletter post content",
    requires: "admin",
    description: "TipTap content editor for a newsletter post.",
    pathParams: {
      id: {
        type: "number",
        description:
          "Numeric identifier of the newsletter post for the content editor.",
      },
    },
  }),

  postSettings: route("/settings/newsletter/posts/:id/settings", {
    title: "Newsletter post settings",
    requires: "admin",
    description: "Meta settings for a newsletter post.",
    pathParams: {
      id: {
        type: "number",
        description:
          "Numeric identifier of the newsletter post for the settings page.",
      },
    },
  }),
};

export const newsletterHomePath = (isOverviewEnabled: boolean) =>
  isOverviewEnabled ? newsletterRoutes.overview() : newsletterRoutes.posts();
